export const INPUT_GROUP_STYLES = [
    "width",
    "border",
    "border-color",
    "border-top",
    "border-bottom",
    "border-left",
    "border-right",
    "border-radius",
    "background",
    "background-color",
    "display",
    "outline",
];

export const INPUT_OMIT_STYLES = ["border", "border-top", "border-bottom", "border-left", "border-right", "outline"];
